import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import actionTypes from '../actionTypes';
var SET_STATE = actionTypes.SET_STATE;
export default (function (_a) {
    var context = _a.context;
    return {
        onStoreCreated: function (store) {
            var Provider = function (props) {
                var children = props.children, initialStates = props.initialStates;
                if (initialStates) {
                    Object.keys(initialStates).forEach(function (name) {
                        var initialState = initialStates[name];
                        if (initialState && store.dispatch[name][SET_STATE]) {
                            store.dispatch[name][SET_STATE](initialState);
                        }
                    });
                }
                return (
                // @ts-ignore
                React.createElement(ReduxProvider, { store: store, context: context }, children));
            };
            return { Provider: Provider, context: context };
        },
    };
});
